<template>
  <tg-layout prefixCls="assistence">
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <tg-dropdown :items="dropdown" @on-change="handleChange" trigger="click">
          <template slot="icon">
            <i class="tg-icon tg-icon-save"></i>
          </template>
        </tg-dropdown>
        <el-input
          :placeholder="$t('component.form.input.placeholder.member')"
          v-model="searchData.target_name"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      cell-class-name="clickable"
      showPagination
      :zebra="false"
      @cell-click="handleCellClick"
      @expand-change="handleExpandChange"
    >
      <template slot="check_status" slot-scope="scope">
        <p class="assistence_check_status">
          <i
            v-if="!isSub && scope.row['checked_status'] == 0"
            class="ckeck_tag"
          ></i>
          <span>{{ scope.value }}</span>
        </p>
      </template>
      <template slot="expand" slot-scope="scope">
        <el-container class="assisten--response" style="word-break: break-word;">
          <el-header style="height: unset;">
            <el-row type="flex" align="middle">
              <p style="padding-right: 30px;">{{ scope.row.assistent_content }}</p>
              <div class="spacer"></div>
              <tg-button
                v-if="!isSub && !scope.row.response && !isHistory"
                class="assistence-reply--btn"
                icon="reply"
                border
                hoverBorderOnly
                theme="info"
                @click.native="showReplyForm(scope.row.report_id)"
              ></tg-button>
            </el-row>
          </el-header>
          <el-main
            :ref="scope.row.report_id"
            class="assistence_reply--container"
            :class="{ collapse: !scope.row.response }"
          >
            <template v-if="scope.row.response">
              <p>
                {{
                  $t("page.assistence.responder", {
                    group: $t("column.l" + scope.row.responder_group),
                  })
                }}: {{ scope.row.response }}
              </p>
            </template>
            <template v-else>
              <div>
                <form @submit="handleSubmit($event, scope.row.report_id)">
                  <textarea
                    class="assistence_reply--input"
                    :ref="scope.row.report_id + '_reply'"
                    autocomplete="false"
                    value
                    maxlength="500"
                  ></textarea>

                  <el-row type="flex" class="reply-btn--group">
                    <tg-button round type="submit" class="active--gradient">{{
                      $t("component.btn.confirm")
                    }}</tg-button>
                    <tg-button round type="reset" border>{{
                      $t("component.btn.cancel")
                    }}</tg-button>
                  </el-row>
                </form>
              </div>
            </template>
          </el-main>
        </el-container>
      </template>

      <template slot="action" slot-scope="scope" v-if="!isHistory && !isSub">
        <el-row
          type="flex"
          justify="space-between"
          align="middle"
          class="assistence--action"
        >
          <i class="tg-icon tg-icon-mark" @click="handleAddMark(scope.row)"></i>
          <i class="tg-icon tg-icon-trash" @click="handleRemove(scope.row)"></i>
        </el-row>
      </template>
    </tg-table>
    <tg-dialog
      :subject="subject"
      :note="note"
      :visible.sync="showDialog"
      @on-confirm="handleConfirm"
      showFooter
      showCancelBtn
      width="20%"
      :theme="theme"
    ></tg-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgSearchTool from "@/components/tool/TgSearchTool";

import apis from "@/apis";

const api = apis.assistence;

export default {
  components: {
    TgLayout,
    TgTable,
    TgButton,
    TgDialog,
    TgDropdown,
    TgSearchTool,
  },
  data() {
    return {
      columns: [],
      normalColumns: [],
      columnsWithAction: [],
      proxy: api.getData,
      isHistory: false,
      showDialog: false,
      subject: "",
      note: "",
      dialogConfirm: null,
      theme: "info",
      dropdown: [],
      searchData: {
        target_name: "",
        status: 0,
      },
    };
  },
  created() {
    api.getColumns().then((response) => {
      let columns = response.data;

      this.columnsWithAction = [
        ...columns,
        {
          name: "action",
          slot: "action",
          width: 80,
          headerClass: "no-border",
          class: "no-border",
        },
      ];

      this.normalColumns = columns;
      this.dropdown = response.dropdown;

      this.$nextTick(() => {
        this.columns = this.columnsWithAction;
        this.$refs.table.init(this.request);
      });
    });
  },
  computed: {
    request() {
      return { ...this.searchData};
    },
  },
  methods: {
    handleSearch(){
      this.columns = this.searchData.status===1 ? this.normalColumns : this.columnsWithAction;
      if(this.searchData.status === 1){
        this.isHistory = true;
      }else{
        this.isHistory = false;
      }
      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    handleCellClick(row, column) {
      if (column.columnKey != "action") {
        this.$refs.table.$refs.ElTable.toggleRowExpansion(row);
      }
    },
    showReplyForm(ref) {
      this.$refs[ref].$el.classList.toggle("in");
    },
    handleSubmit(e, report_id) {
      e.preventDefault();
      let ref = this.$refs[report_id + "_reply"];
      let response = ref.value;

      this.subject = this.$t("page.assistence.action.reply");
      this.note = response;

      this.dialogConfirm = () => {
        api
          .reply({ report_id, response })
          .then((response) => {
            if(response.retcode == 0)[
              this.showSuccessAlert("reply")
            ]
          })
          .catch(() => {});
      };
      this.theme = "info";
      this.showDialog = true;
    },
    handleConfirm() {
      if (this.dialogConfirm) {
        this.dialogConfirm();
      }
    },
    handleChange(item){
      this.searchData.status = this.dropdown.findIndex(x => x == item.label);
    },
    handleAddMark(row) {
      this.subject = this.$t("page.assistence.action.mark");

      this.dialogConfirm = () => {
        api
          .archive({
            report_id: row.report_id,
          })
          .then((response) => {
            if(response.retcode == 0){
              this.showSuccessAlert("mark");
            }
          })
          .catch(() => {});
      };
      this.theme = "info";
      this.showDialog = true;
    },
    handleRemove(row) {
      this.subject = this.$t("page.assistence.action.remove");

      this.dialogConfirm = () => {
        api
          .remove({
            report_id: row.report_id,
          })
          .then((response) => {
            if(response.retcode == 0){
              this.showSuccessAlert("remove");
            }
          })
          .catch(() => {});
      };
      this.theme = "warning";
      this.showDialog = true;
    },
    showSuccessAlert(type) {
      this.$message.success({
        message: this.$t("page.assistence.success." + type),
        onClose: () => {
          this.$refs.table.init(this.request);
        },
      });
    },
    handleExpandChange(row, expanded) {
      // open
      if (expanded.find((x) => x == row)) {
        if (row.checked_status == 0 && !this.isSub) {
          api.read({ report_id: row.report_id }).then((response) => {
            if(response.retcode == 0){
              row.checked_status = 1;
              this.$store.commit("app/update_badge", {
                name: "assistence",
                diff: -1,
              });
            }
          });
        }
      }
    },
  },
    watch: {
    isHistory(val) {
      console.log(val);
    },
  },
};
</script>